import { Grid, GridProps, Typography, TypographyProps } from '@mui/material';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';

const CountProps: TypographyProps = {
  color: '#005FCC',
  textAlign: 'center',
  fontWeight: 800,
  fontSize: { xs: 30, lg: 58 },
};

const DescriptionProps: TypographyProps = {
  color: '#2C3E50',
  textAlign: 'center',
  fontWeight: 600,
  fontSize: { xs: 11, lg: 16 },
  maxWidth: '200px',
  mx: 'auto',
  mt: 1,
  textTransform: 'uppercase',
  lineHeight: 1.25,
};

const GridItemProps: GridProps = {
  xs: 6,
  md: 6,
  lg: 3,
  px: 1,
  py: 2,
};

const borderStyles = '1px solid #D9E0E1';

// --- Values you want to display (also used for SSR) ---
const STATS = [
  { value: 10, suffix: 'x', label: 'Source-to-Pay Return on Investment' },
  { value: 90, suffix: '%', label: 'First time match rate' },
  { value: 6500, suffix: '', label: 'Purchase Orders per FTE' },
  { value: 30000, suffix: '', label: 'Invoices per FTE' },
];

const Statistics = () => {
  // We detect client-side to run animation
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true); // Enables animation after hydration
  }, []);

  return (
    <div style={{ paddingBlock: '4rem' }}>
      <div className='page__content'>
        <Typography
          color='#3A3E50'
          fontWeight={600}
          fontSize={{ xs: 26, lg: 44 }}
          textAlign={'center'}
          mb={3}
          lineHeight={1}
          component='h2'
        >
          Real Results, Real ROI
        </Typography>

        <Grid container>
          {STATS.map((item, i) => (
            <Grid
              key={i}
              {...GridItemProps}
              sx={{
                borderRight: {
                  xs: i % 2 === 0 ? borderStyles : 'none',
                  md: i % 2 === 0 ? borderStyles : 'none',
                  lg: i < 3 ? borderStyles : 'none',
                },
                borderBottom: {
                  xs: i < 2 ? borderStyles : 'none',
                  md: i < 2 ? borderStyles : 'none',
                  lg: 'none',
                },
              }}
            >
              <Typography {...CountProps}>
                {isClient ? (
                  <CountUp
                    end={item.value}
                    duration={2.5}
                    enableScrollSpy
                    scrollSpyOnce
                    suffix={item.suffix}
                    separator=','
                  />
                ) : (
                  // SSR fallback for SEO
                  `${item.value.toLocaleString()}${item.suffix}`
                )}
              </Typography>

              <Typography {...DescriptionProps}>{item.label}</Typography>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default Statistics;
